import { useState } from "react";

import Typography from "@mui/material/Typography";

import Box from "ui/atom/Box";
import Accordion from "ui/base/Accordion";
import Image from "ui/base/Image";

import mobilePreview from "assets/mobile-preview.png";


const items = [
	{
		question: "What is Subly?",
		answer: "It lets you buy single articles from multiple sources. Unlocking articles is instant and affordable."
	},
	{
		question: "Subly Lets You Read",
		answer: "No Subscription? No problem! Click Unlock, then Read. Boom, done! Reading shouldn’t be a battle."
	},
	{
		question: "Subly is Not a Subscription",
		answer: "Pay as you read. No recurring subscription costs. You put a small amount on your credit card and get a bunch of tokens to use over time. It's like a coffee shop card or a toll pass for great journalism."
	},
	{
		question: "We Won't Fill Your Inbox!",
		answer: "We get it. You just want to read this one thing. Do it without getting an email from us every morning!"
	},
	{
		question: "What is a Subly Token?",
		answer: "It's a ticket to knowledge, information, and stories. It works like a carnival, most articles take just one token. A few big ones may cost a little more."
	},
	{
		question: "How Much is a Subly Token?",
		answer: "Subly tokens are just a quarter (25¢) in the US. Subly tokens work like tokens at a carnival or an arcade."
	},
	{
		question: "What is a Day Pass?",
		answer: "A Day Pass is like buying today's paper at a digital newsstand. Just drop in a few tokens and unlock the whole paper. It’s like buying a one-day ski pass versus a season ticket."
	}
];

export default function Faq() {
	const [open, setOpen] = useState(0);
	const style = {
		root: {
			alignItems: "center",
			textAlign: "center"
		},
		content: {
			flexWrap: "wrap",
			alignItems: "center",
			justifyContent: "center"
		},
		image: {
			width: "100%",
			maxWidth: "260px",
			boxShadow: "0 0 48.885px -11.908px #d4a4ff",
			borderRadius: "46px",
			mx: "auto"
		},
		faq: {
			maxWidth: "400px",
			mx: "auto"
		},
		accordion: {
			backgroundImage: "none",
			boxShadow: "none",
			"&:before": {
				backgroundColor: "rgba(255, 255, 255, 0.21)"
			}
		},
		details: {
			textAlign: "left"
		}
	};

	const change = (v) => setOpen(s => s === v ? null : v);

	return (
		<Box.Column id="faq" gap={4} sx={style.root}>
			<Typography variant="h1" fontSize={22}>Subly lets you buy one article at a time, without a subscription.</Typography>
			<Box gap={4} sx={style.content}>
				<Image src={mobilePreview} sx={style.image} />
				<Box.Column sx={style.faq}>
					{items.map((i, k) => (
						<Accordion
							expanded={open === k}
							onChange={() => change(k)}
							slotProps={{ root: { sx: style.accordion } }}
							key={k}
						>
							<Accordion.Summary icon={open === k ? "minus" : "plus"} variant="reverse">
								{i.question}
							</Accordion.Summary>
							<Accordion.Details sx={style.details}>{i.answer}</Accordion.Details>
						</Accordion>
					))}
				</Box.Column>
			</Box>
		</Box.Column >
	);
};